import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ApiManager from "../../api/ApiManager";

export const fetchTraders = createAsyncThunk('dashboard/fetchTraders', () => ApiManager.fetchTraders())
export const fetchTraderDetails = createAsyncThunk('dashboard/fetchTraderDetails', (traderId: string) => ApiManager.fetchTraderDetails(traderId))
export const addTrader = createAsyncThunk('dashboard/addTrader', (traderData: any) => ApiManager.addTrader(traderData))
export const editTrader = createAsyncThunk('dashboard/editTrader', (traderData: any) => ApiManager.editTrader(traderData))

const resellersSlice = createSlice({
    name: 'resellers',
    initialState: {
        traders: {
            data: [] as {
                id: string;
                name: string;
                surname: string;
                email: string;
                phone: string;
                commission1: string;
            }[],
            loaded: false as boolean,
            loading: false as boolean,
            error: null as null | string
        },
        traderDetails: {
            ordersActual: [] as {}[],
            ordersClosed: [] as {}[],
            loaded: false as boolean,
            loading: false as boolean,
            error: null as null | string
        },
    },
    reducers: {
        setTradersLoading: (state, action) => {
            state.traders.loading = action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchTraders.fulfilled, (state, action) => {
                state.traders.data = Array.isArray(action.payload) ? action.payload : []
            })
            .addCase(fetchTraderDetails.fulfilled, (state, action) => {
                state.traderDetails.ordersActual = action.payload.actual ? action.payload.actual : []
                state.traderDetails.ordersClosed = action.payload.closed ? action.payload.closed : []
            })
    }
})
export const {
    setTradersLoading,
} = resellersSlice.actions
export default resellersSlice.reducer